import type { FC } from 'react'

import { Input, InputWithValidation } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import { validateEmail } from '@/util/formatters/text'

import { Company } from './Company'

export const BasicInfo: FC = () => {
  const translate = useTranslation()

  return (
    <div className="wrap flex">
      <div className="mx-2 flex flex-1 basis-[30rem] flex-col rounded-lg">
        <Field name="code">
          {({ field, meta }: FieldProps) => (
            <Input
              capitalizeLabel
              isFullWidth
              id="code"
              wrapperClassName="grow"
              ariaLabel={translate('Location ID')}
              label={
                <>
                  <Translation id="Location ID" />*
                </>
              }
              marginBottom={16}
              touched={meta.touched}
              error={meta.error}
              {...field}
            />
          )}
        </Field>

        <Field name="name">
          {({ field, meta }: FieldProps) => (
            <Input
              capitalizeLabel
              isFullWidth
              id="name"
              className="description-input"
              ariaLabel={translate('Name')}
              label={
                <>
                  <Translation id="Name" />*
                </>
              }
              marginBottom={16}
              touched={meta.touched}
              error={meta.error}
              {...field}
            />
          )}
        </Field>

        <Field name="email">
          {({ field, meta }: FieldProps) => (
            <InputWithValidation
              capitalizeLabel
              isFullWidth
              id="email"
              type="email"
              validator={validateEmail}
              errorMessage={<Translation id="Invalid email format" />}
              ariaLabel={translate('Email')}
              label={
                <>
                  <Translation id="Email" />*
                </>
              }
              marginBottom={16}
              touched={meta.touched}
              error={meta.error}
              {...field}
            />
          )}
        </Field>
      </div>

      <div className="mx-2 flex flex-1 basis-[30rem] flex-col rounded-lg">
        <Company />

        <Field name="description">
          {({ field, meta }: FieldProps) => (
            <Input
              capitalizeLabel
              isFullWidth
              id="description"
              ariaLabel={translate('Description')}
              label={<Translation id="Description" />}
              marginBottom={16}
              touched={meta.touched}
              error={meta.error}
              {...field}
            />
          )}
        </Field>
      </div>
    </div>
  )
}
